module.exports = __webpack_public_path__ + "static/01-3cf4b78a06b5d15a6927b2630ec071b1.jpg";